var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-group",style:(_vm.groupStyle)},[_vm._l((_vm.members),function(i,idx){return _c('HeaderImage',{key:idx,attrs:{"id":i,"def":true,"size":_vm.size}})}),_vm._v(" "),(_vm.members.length === 0)?_c('img',{staticClass:"question-icon",attrs:{"src":_vm.$images.topic_header_question_ico}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }